import { Component, OnInit } from '@angular/core';
import { NewsService } from '../rest/api/news.service';
import * as _ from 'lodash';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-news-detail',
  templateUrl: './news-detail.component.html',
  styleUrls: ['./news-detail.component.scss']
})
export class NewsDetailComponent implements OnInit {
  newsDetail: any;
  lang: any;
  newsList: any;
  pageLoader = true;
  errMessage: string;

  constructor(
    public route: ActivatedRoute,
    public newsService: NewsService,
    public translateService: TranslateService,
    public router: Router,
  ) { }

  ngOnInit() {
    this.lang = this.translateService.currentLang ? this.translateService.currentLang :
    (localStorage.getItem('language') ? localStorage.getItem('language') : '');
    this.route.params.subscribe(params => {
      if (!params.slug) {
        this.router.navigate(['/']);
      }
      this.getNewsDetail(params.slug);
      this.getAllNewsList();
    });
  }

  getNewsDetail(slug) {
    const thisobject = this;
    this.newsService.getSingleNews({
      slug: slug,
      lang: this.lang
    }).subscribe((response: any) => {
      thisobject.pageLoader = false;
      this.newsDetail = response.data;
    }, err => {
      if (err && err.status === 404) {
        this.errMessage = err && err.error && err.error.errors && err.error.errors['0'] && err.error.errors['0'].title;
        const th = this;
        setTimeout(() => {
          th.errMessage = undefined;
          th.router.navigate(['/news']);
        }, 2500);
      }
      thisobject.pageLoader = false;
      this.newsDetail = [];
      this.newsDetail = undefined;
    });
  }
  getAllNewsList() {
    const thisobject = this;
    const limit = 9;
    const page = 1;
    this.newsService.getNewsList({
      page: page,
      paginate: limit,
      lang: this.lang
    }).subscribe((response: any) => {
      this.newsList = response.data;
      this.newsList = _.orderBy(this.newsList, ['published_at'], ['desc']);
    }, err => {
      console.log(err && err.error);
    });
  }

  getMonth(data) {
    const check = moment(data.published_at, 'YYYY/MM/DD');
    const month = check.format('MMM');
    return month;
  }

  getDate(data) {
    const check = moment(data.published_at, 'YYYY/MM/DD');
    const day   = check.format('D');
    return day;
  }
}
